import ProductFullscreen from "components/Product/ProductFullscreen"
import ProductPath from "components/ProductPath"
import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import Variants from "components/Variants/Variants"
import {Link} from "react-router-dom"
import shop from "shop/shop"
import {Col, Row} from "elemental-react16"
import {Breadcrumb, Button, Card, Container, Icon, Input, Popup, Select, Table} from "semantic-ui-react"
import View3D from "components/Product/View3D"
import ProductSearch from "components/Product/ProductSearch"
import ProductSearchExtra from "components/Product/ProductSearchExtra"
import ProductList from "components/Product/ProductList"
import ProductQuantityGroup from "components/Product/ProductQuantityGroup"
import ProductCard from "components/Product/ProductCard"
import Badge from "components/Product/Badge"
import Price from "components/Price/Price"
import ProductPrice from "components/Product/ProductPrice"

import productStore from "stores/productStore"
import _ from "lodash"
import "style/ProductPage.scss"

let lastProducts = null

const IconImage = ( { src, description } ) => <Popup content={description}
                                                     trigger={<img className="mr2 icon-product-attribute" width="42"
                                                                   src={src} alt=""/>}/>

export default class ProductPage extends Component {
  constructor( props ) {
    const { match } = props
    super()
    this.state = {
      id:                match.params.productId,
      product:           {},
      fullscreenElement: null,
      variants:          false
    }
  }
  
  loadProduct( id ) {
    if ( this.id === id ) return
    this.id = id
    productStore.get( id )
      .then( product => {
        console.log( "ProductPage::product", product )
        product.count = 1
        let inCart = shop.cart.productsById.get( product.map_id )
        if ( inCart ) product.count = Number( inCart.count )
        shop.analytics.push( product.map_id )
        lastProducts = shop.analytics.lastProducts( 4 )
          .filter( ( id ) => id !== product.map_id )
        this.setState( { product: product, primaryImage: false } )
        
        if ( !product.mainart ) return
        //productStore.partlist( product.mainart )
        //  .then( variants => {
            
            // let colors = variants.products.map( product => {
            //   return {
            //     color:  product.extras.Farbe,
            //     map_id: product.map_id
            //   }
            // } )
            
        //    let byAttribute = {}
        //    variants.variants.varfields.forEach( varfield => {
        //      let categories = _.groupBy( variants.products, `extras.${varfield}` )
        //      var ordered = {};
        //      _( categories ).keys().sort().each( function ( key ) {
        //        ordered[ key ] = categories[ key ];
        //      } );
        //      byAttribute[ varfield ] = ordered
        //      
        //    } )
        //    this.setState( { variants, byAttribute } )
        //  } )
      } )
  }
  
  add = ( { product } ) => {
    //if ( product.count === 0 ) return shop.cart.remove( product )
    console.log(shop.whoami())
    shop.toast( `${product.count * product.unit_multi} Stück ${product.title} ${translate("im Warenkorb")}`, "info", false, "bottom" )
    return shop.cart.add( product )
  }
  
  updateProduct = ( { product } ) => {
    this.setState( { product } )
  }
  
  componentWillReceiveProps( { match } ) {
    let { productId } = match.params
    this.loadProduct( productId )
  }
  
  showFullscreen = ( element ) => {
    this.setState( {
      fullscreenElement: element
    } )
  }
  
  setPrimaryImage = ( primaryImage ) => {
    this.setState( { primaryImage } )
  }
  
  componentDidMount() {
    this.loadProduct( this.state.id )
  }
  
  render() {
    let { fullscreenElement, product, byAttribute, primaryImage } = this.state
    
    if ( !product._type ) return null //  duck type check for ProductModel
    let img_srcs = product.img_srcs
    
    let category = product.cats[ 0 ] && product.cats[ 0 ] || {}
    let cat_id = category.cat_id
    
    let productImage
    if ( product.img_src ) {
      productImage = product.img_src_large
    }
    
    if ( primaryImage ) productImage = primaryImage
    
    // let categoryName = shop.categoryName(product.cats[0].cat_id)
    let path = shop.getCategoryPath( cat_id )
    
    path.push( {
      title: product.title,
      link:  ""
    } )
    
    const veOptions = product.quantities.map( q => {
      return (
        {
          key:   q.map_desc_id,
          text:  `${q.des} (${q.multi})`,
          value: q.map_desc_id
        }
      )
    } )
    // const veOptions = [
    //   { key: 'all', text: 'All', value: 'all' },
    //   { key: 'articles', text: 'Articles', value: 'articles' },
    //   { key: 'products', text: 'Products', value: 'products' },
    // ]
    
    
    return (
      <div className="bg-white ">
        <Container className="relative  ">
          <ProductFullscreen
            change={this.showFullscreen}
            images={img_srcs}
            image={fullscreenElement}/>
          
          <div className="db pv3 ">
            <Breadcrumb>
              <Breadcrumb.Section link as={Link} to="/">Home</Breadcrumb.Section>
              <Breadcrumb.Divider/>
              {path.map( segment => {
                if ( !segment.link ) return <Breadcrumb.Section key={segment.title} active style={{ whiteSpace: "nowrap" }}>{segment.title}</Breadcrumb.Section>
                return <React.Fragment key={segment.title}>
                  <Breadcrumb.Section link as={Link} to={segment.link}>{segment.title}</Breadcrumb.Section>
                  <Breadcrumb.Divider/>
                </React.Fragment>
              } )
              }
            </Breadcrumb>
          </div>
          
          {/*<Breadcrumbs path={path}/>*/}
          <section className="product product-single pb6-ns pb5">
            <ProductPath path={path} title={product.title} product={product}/>
            <Row>
              <Col sm="1" md="1/2" lg="7/12" className="relative">
                <div className="absolute right-2 pr3"><Badge product={product}/></div>
                <ProductImages
                  key={product.map_id}
                  product={product} images={img_srcs} image={productImage}
                  onClick={this.showFullscreen}
                  onClickSecondary={this.setPrimaryImage}/>
              </Col>
              <Col sm="1" md="1/2" lg="5/12">
                <TitleSection product={product}/>
                {/*{shop.session && <ActionSection product={product}*/}
                {/*onChange={this.updateProduct}*/}
                {/*onAdd={this.add}/>*/}
                {/*}*/}
                {shop.session &&
                <div className="product-actions">
                  {product &&
                  <Input type="number" min={0} placeholder="1" defaultValue={product.count} action onChange={e => {
                    this.setState( { count: e.target.value } )
                  }
                  }>
                    <input/>
                    <Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[ 0 ].map_desc_id}
                            onChange={( e, data ) => {
                              const { value } = data
                              const ve = product.quantities.filter( q => q.map_desc_id === value )
                              if ( !ve ) return
                              product.unit_multi = ve[ 0 ].multi
                              product.unit_id = ve[ 0 ].map_desc_id
                              console.log( { data, e, value: e.target.value, target: e.target } )
                            }
                            }
                    />
                    <Button color={"primary"} icon={"shopping cart"} onClick={() => {
                      product.count = this.state.count || 1
                      console.info( "BUY", this.state.count, product.unit_multi, product.unit_id )
                      this.add( { product } )
                      shop.whoami()
                    }
                    }/>
                  </Input>
                  }
                
                </div>}
                
                
                <DescriptionSection product={product}/>
                {<BulkPricing product={product}/>}
                {!shop.session && <div>
                  <p>
                    {translate( "shop.please_login_for_product_details" )}
                  </p>
                  
                  <div className="mw6">
                    <div className="pb2">
                      <Link to={`/login?referrer=${location.pathname}`}><Button fluid> {translate( "shop.login" )}</Button></Link>
                    </div>
                    <Link to="/customer_registration"><Button fluid> {translate( "shop.register" )}</Button></Link>
                  </div>
                </div>}
                {shop.session && <TechnicalTable product={product}/>}
                
                <br/>
                <br/>
                <section>
                  <Variants byAttribute={byAttribute} product={product}/>
                  {/*{variants && variants.products && variants.products.map( variant => <ProductVariant key={variant.map_id} product={variant}/> )}*/}
                  {/*<pre>{JSON.stringify( variants && variants.variants.varfields, null, 2 )}</pre>*/}
                </section>
              </Col>
            </Row>
          </section>
        </Container>
        
        
        {product.extras.Kollektion && <div className="bg-silver pv4">
          <Container>
            <section className=" pt3 pb5">
              
              <div className="cf relative pb3">
                {product.category.desc &&
                <Link to={`/collection-extra/Kollektion/${product.extras.Kollektion}`}><h2
                  className="mt2 ttu">{`${translate("Weitere Artikel ")}`} <Icon
                  name="chevron right"/></h2>
                </Link>}
              </div>
              <ProductSearchExtra
                count={4}
                start={0}
                extra={"Kollektion"}
                extraValue={product.extras.Kollektion}
                query="%%"
                repeat={ProductCard}/>
            </section>
          
          </Container>
        </div>}
        
        
        {product.category && <div className="pv4">
          <Container>
            <section className="section-product-slider">
              <div className="cf relative pb3">
                {product.category.desc && <Button basic as={Link} to={`/collection/${product.category.map_id}`}><h2
                  className="mt2 ttu">{`${translate("Weitere Artikel")}`} <Icon name="chevron right"/></h2>
                </Button>}
              </div>
              <ProductSearch
                count={4}
                start={0}
                cats={[cat_id]}
                query="%%"
                repeat={ProductCard}/>
            </section>
          </Container>
        </div>}
        
        <div className="pv4 bg-silver">
          <Container>
            {/*Product Slider "last viewed"*/}
            <section className="section-product-slider pv5">
              <h2 className="mt2  ttu">{translate("Zuletzt angesehen")}</h2>
              <ProductList
                count={4}
                start={0}
                list={lastProducts}
                repeat={ProductCard}/>
            </section>
          </Container>
        </div>
      </div>
    )
  }
}

ProductPage.propTypes = {
  price: PropTypes.any
}


const ProductVariant = ( { product } ) => {
  return (
    <Card as={Link} to={`/product/${product.map_id}`}>
      <img className="ui image" src={product.img_src_medium}/>
      <div>{product.extras.Art}</div>
      <div>{product.extras.Groesse}</div>
    </Card>
  )
}

const BulkPricing = ( { product } ) => {
  if ( !product.prices || product.prices.length === 1 ) return null
  return (
    
    <div>
      <h4>{translate("Staffelpreise")} </h4>
      <Table>
        <tbody>
        {product.prices.map( price => (
          <tr key={price.q}>
            <td>{translate("ab")} {price.q} {translate("Stück")}</td>
            <td><Price>{price.p}</Price></td>
          </tr>
        ) )}
        </tbody>
      </Table>
    
    </div>
  )
}


const TechnicalTable = ( { product } ) => {
  return (
    <div className="pt2">
      <div className="TopBotMenufrankenstolz" style={{maxHeight: "3px"}}></div>
      <div className="pb3"></div>
      <h4>Details</h4>
      <Table>
        <tbody>
        {product.quantities.map( q => {
          return (
            <tr key={q.map_desc_id}>
              <td>
                <label>
                  VE {q.des}
                </label>
              </td>
              <td>
                {q.multi} {translate(product.baseUnitDisplayName)}
              </td>
            </tr>
          )
        } )}
        
        <tr>
          <td>
            <label>
              EAN
            </label>
          </td>
          <td>
            {product.barcode}
          </td>
        </tr>
        </tbody>
      </Table>
    </div>
  )
}

TechnicalTable.propTypes = {
  product: PropTypes.object
}

const AdditionalTable = ( { product } ) => {
  return (
    <section className="AdditionalTable">
      <Row>
        <Col sm="1" md="1" className="pb3">
          <div className="technischetabelle">
            <strong>weitere Details</strong>
            <table className="table-technical">
              <tbody>
              {product && shop.session.group !== "WERBE" ? <tr>
                <td>UVP inkl. MwSt.</td>
                <td className="text-right"><Price className="fw1">{product.extras.evkpre}</Price></td>
              </tr> : null}
              {product && shop.session.group === "WERBE" ? <tr>
                <td>Industriepreis Netto</td>
                <td className="text-right"><Price className="fw1">{product.extras.indpre}</Price></td>
              </tr> : null}
              {product ? <tr>
                <td>EAN</td>
                <td className="text-right">{product.barcode}</td>
              </tr> : null}
              {product && product.extras.premium && product.extras.premium.value.value == "Ja" ? <tr>
                <td>Premiumprodukt</td>
                <td className="text-right">{"Ja"}</td>
              </tr> : null}
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </section>
  )
}

AdditionalTable.propTypes = {
  product: PropTypes.object
}

const TitleSection = ( { product } ) => (
  <section className="product-title mb0 pb0">
    <div className="brand">{product.extras.herst !== "unbekannt" &&
    <Link to={`/brand/${product.extras.herst}`}>{product.extras.herst}</Link>}</div>
    <div className="title f3 f2-ns b lh-copy">{product.desc.short_des}</div>
    <div className="id pt2 pb2">{translate("Artikel-Nr.")}: {product.article_nr || product.article_id || product.map_id}</div>
    <div className="TopBotMenufrankenstolz" style={{maxHeight: "3px"}}></div>
    {/* Price*/}
    {<ProductPrice product={product}/>}
    
    {/* Availability*/}
    {shop.config.useAvailability !== false && <Availability product={product}/>}
  </section>
)

TitleSection.propTypes = {
  product: PropTypes.object
}

const Availability = ( { product } ) => {
  let notice = product.getNotice()
  return (
    <div className="availability">
      {notice}
    </div>
  )
}

const ActionSection = ( { product, onChange, onAdd } ) => {
  if ( !product.canBeBought ) return null
  const list = shop.orderlist.default
  return (
    <section className="product-actions pt2 pb4">
      <div style={{ display: "inline-block " }}>
        <p>
          {product.count * product.unit_multi} Stück <Price
          className="f5 fw2 black-50">{product.count * product.unit_multi * product.price}</Price></p>
        
        <ProductQuantityGroup product={product}
                              list={list}
                              showVE={false}
                              onChange={onChange}
                              onAdd={onAdd}
                              large/>
      </div>
    </section>
  )
}

ActionSection.propTypes = {
  product:  PropTypes.object,
  onChange: PropTypes.func,
  onAdd:    PropTypes.func,
}

const DescriptionSection = ( { product } ) => (
  <section className="description pv3 lh-copy">
    {product.desc.des}
  </section>
)
DescriptionSection.propTypes = {
  product: PropTypes.object,
}

class ProductImages extends Component {
  
  render() {
    const { images, image, onClick, onClickSecondary, product } = this.props
    return (
      <div>
        <div className="tc">
          <a key={product.map_id} className="image text-center product-image-main"
             onClick={() => {
               onClick( image )
             }}>
            
            <img
              src={image}
              className="img-responsive"
              style={{ maxHeight: "520px" }}
              alt=""/>
          </a>
        </div>
        <div className="product-images">
          {images.map( ( { img_src_large, img_src_medium } ) => (<img
            alt={product.title}
            className="img-thumbnail"
            key={img_src_medium}
            onClick={() => {
              onClick( img_src_medium )
            }}
            src={img_src_medium}/>) )}
          {shop.config.plugin[ "view3D" ] && <View3D id={product.map_id} title={product.desc.short_des}/>}
        </div>
      </div>
    )
  }
}

ProductImages.propTypes = {
  images:  PropTypes.any,
  image:   PropTypes.any,
  onClick: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/theme/braunco/pages/ProductPage.js